import Holidays from "date-holidays";

const cache = new Map<number, Map<string, string>>();

function getHolidayMap(year: number): Map<string, string> {
  if (cache.has(year)) return cache.get(year)!;
  const hd = new Holidays("US");
  const map = new Map<string, string>();
  for (const h of hd.getHolidays(year)) {
    if (h.type === "public") {
      map.set(h.date.slice(0, 10), h.name);
    }
  }
  cache.set(year, map);
  return map;
}

/** Returns the US federal holiday name for a "YYYY-MM-DD" string, or null if not a holiday. */
export function getHolidayName(dateStr: string): string | null {
  const year = parseInt(dateStr.slice(0, 4), 10);
  return getHolidayMap(year).get(dateStr) ?? null;
}
